import AddPlayer from "plos/src/components/ElementCard/AddPlayer";
import { pitchElementData } from "plos/src/components/ElementCard/ElementCard.css";
import ElementCardButton from "plos/src/components/ElementCard/ElementCardButton";
import ElementName from "plos/src/components/ElementCard/ElementName";
import ElementTypeLabel from "plos/src/components/ElementTypeLabel";
import ElementOverlayValue from "../../PitchControls/ElementOverlayValue";
import { removedElement } from "./elementSavedCard.css";
import { ElementSavedCardProps } from "./types";

const ElementSavedCard = ({
  renderElementMenu,
  elementType,
  element,
  nextEvent,
  copnr,
  pick,
}: ElementSavedCardProps) => {
  return (
    <ElementCardButton onPress={renderElementMenu}>
      <div className={removedElement}>
        <div>
          <AddPlayer />
          <ElementTypeLabel elementType={elementType} />
        </div>
        <div className={pitchElementData.removed}>
          <ElementName copnr={element.news ? copnr : null}>
            {element.web_name}
          </ElementName>
          <ElementOverlayValue pick={pick} eventId={nextEvent?.id} />
        </div>
      </div>
    </ElementCardButton>
  );
};

export default ElementSavedCard;
